import { Component, OnInit } from '@angular/core';
import { DataStoreService } from '../../core/services/data-store/data-store.service';

@Component({
  selector: 'baf-error-view',
  templateUrl: './error-view.component.html',
  styleUrls: ['./error-view.component.css']
})
export class ErrorViewComponent implements OnInit {
  msgAuth = 'Trwa autoryzacja użytkownika.';
  msgConfig = 'Błąd pobierania konfiguracji.';
  msgData = 'Błąd pobierania danych.';
  msgConnection =
    'Brak komunikacji z usługą. Proszę skontaktować się z administratorem systemu:';
  msgMain = '';
  showMail = false;

  constructor(service: DataStoreService) {
    service.getErrorId().subscribe(eId => {
      if (eId === 1) {
        this.msgMain = this.msgAuth;
      }
      if (eId === 2) {
        this.msgMain = this.msgConfig;
      }
      if (eId === 3) {
        this.msgMain = this.msgData;
      }
      if (eId === 4) {
        this.msgMain = this.msgConnection;
        this.showMail = true;
      }
    });
  }

  ngOnInit() {}
}



// WEBPACK FOOTER //
// ./src/app/components/error-view/error-view.component.ts